__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "marketing-demos-mfe";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@goconsensus/common", "0.6.12", () => (Promise.all([__webpack_require__.e(35), __webpack_require__.e(854), __webpack_require__.e(953), __webpack_require__.e(862), __webpack_require__.e(527)]).then(() => (() => (__webpack_require__(2035))))));
			register("@goconsensus/uikit", "0.8.3", () => (Promise.all([__webpack_require__.e(85), __webpack_require__.e(854), __webpack_require__.e(482), __webpack_require__.e(108), __webpack_require__.e(453)]).then(() => (() => (__webpack_require__(7085))))));
			register("@hello-pangea/dnd", "17.0.0", () => (Promise.all([__webpack_require__.e(716), __webpack_require__.e(854), __webpack_require__.e(482)]).then(() => (() => (__webpack_require__(6716))))));
			register("@hookform/resolvers", "3.3.4", () => (Promise.all([__webpack_require__.e(983), __webpack_require__.e(619)]).then(() => (() => (__webpack_require__(619))))));
			register("@tanstack/react-query-devtools", "5.45.1", () => (__webpack_require__.e(899).then(() => (() => (__webpack_require__(1237))))));
			register("@tanstack/react-query", "5.28.4", () => (Promise.all([__webpack_require__.e(412), __webpack_require__.e(854), __webpack_require__.e(105)]).then(() => (() => (__webpack_require__(9412))))));
			register("axios", "1.6.8", () => (__webpack_require__.e(686).then(() => (() => (__webpack_require__(686))))));
			register("clipboard-polyfill", "3.0.3", () => (__webpack_require__.e(697).then(() => (() => (__webpack_require__(9914))))));
			register("history", "4.9.0", () => (__webpack_require__.e(728).then(() => (() => (__webpack_require__(3728))))));
			register("i18next", "21.6.11", () => (__webpack_require__.e(542).then(() => (() => (__webpack_require__(542))))));
			register("lodash.debounce", "4.0.8", () => (__webpack_require__.e(763).then(() => (() => (__webpack_require__(6763))))));
			register("lodash.isequal", "4.5.0", () => (__webpack_require__.e(914).then(() => (() => (__webpack_require__(5899))))));
			register("qs", "6.14.0", () => (Promise.all([__webpack_require__.e(944), __webpack_require__.e(568)]).then(() => (() => (__webpack_require__(5944))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(422), __webpack_require__.e(854)]).then(() => (() => (__webpack_require__(422))))));
			register("react-helmet-async", "2.0.5", () => (Promise.all([__webpack_require__.e(540), __webpack_require__.e(854)]).then(() => (() => (__webpack_require__(7540))))));
			register("react-hook-form", "7.51.0", () => (Promise.all([__webpack_require__.e(750), __webpack_require__.e(854)]).then(() => (() => (__webpack_require__(7750))))));
			register("react-router-dom", "5.2.0", () => (Promise.all([__webpack_require__.e(237), __webpack_require__.e(854), __webpack_require__.e(724)]).then(() => (() => (__webpack_require__(5237))))));
			register("react", "18.2.0", () => (__webpack_require__.e(959).then(() => (() => (__webpack_require__(959))))));
			register("zod", "3.22.4", () => (__webpack_require__.e(946).then(() => (() => (__webpack_require__(1946))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};